module.exports = __webpack_public_path__ + "img/initial_d_icon.feb3a0d4.jpg";